// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1GqCS","col":"CardReaderDesc_col__NWWns","label":"CardReaderDesc_label__3L8ZJ"};